/**
 * Created by jinbian on 08/11/2017.
 */
import React from "react";
import "./_index.scss";
import Header from "../../Components/Header/index"
import Footer from "../../Components/Footer/index"
import {browserHistory} from 'react-router'

export default class extends React.Component {
    componentDidMount() {

        //

        //
        if (PlatformSDK.isLoggedIn()) {
            PlatformSDK.logout().then(() => {
                browserHistory.replace("/");
            })
        } else {
            browserHistory.replace("/");
        }
    }

    render() {
        return (
            <div>
                <Header/>
                <div className="login-content"></div>
                <Footer/>
            </div>
        )
    }
}